import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Descriptions, Tag, Typography, Spin } from "antd";
import { getUserRoleById } from "../../../redux/slices/UserSlice";
import CustomButton from "../../../components/CustomButton/Button";
import BackButton from "../../../components/CustomButton/BackButton";
import CustomCard from "../../../components/CustomCard/CustomCard";
import "./ManageUsers.scss";
import { GLOBAL_CONSTANTS, ROLE_STYLES } from "../../../constants/constants";
import { capitalizeWords } from "../../../helpers/helpers";

const { Text } = Typography;

const UserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, loading } = useSelector((state) => state.user);
  const { userId } = location.state || {};

  useEffect(() => {
    if (userId) {
      dispatch(getUserRoleById(userId));
    }
  }, [dispatch, userId]);

  const userDetailsItems = [
    {
      key: "userId",
      label: "User ID",
      children: user?.userId || GLOBAL_CONSTANTS.NA,
    },
    {
      key: "userName",
      label: "User Name",
      children: user?.userName || GLOBAL_CONSTANTS.NA,
    },
    {
      key: "organization",
      label: "Organization",
      children: user?.orgName || GLOBAL_CONSTANTS.NA,
    },
    {
      key: "email",
      label: "Email",
      children: user?.email || GLOBAL_CONSTANTS.NA,
    },
    {
      key: "roleName",
      label: "Role",
      children: (
        <Tag
          style={
            ROLE_STYLES[user?.roleName?.toLowerCase()] || ROLE_STYLES.default
          }
        >
          {capitalizeWords(user?.roleName) || GLOBAL_CONSTANTS.NA}
        </Tag>
      ),
    },
    // Only for Field Officer
    ...(user?.User?.userName
      ? [
          {
            key: "regionalManager",
            label: "Regional Manager",
            children: user.User.userName,
          },
        ]
      : []),
    ...(Array.isArray(user?.dealCategories) && user.dealCategories.length > 0
      ? [
          {
            key: "dealCategoryStatus",
            label: "Deal Category Status",
            children: (
              <div className="deal-category-status-list">
                {user.dealCategories.map((category) => (
                  <Text
                    key={category.dealCategoryId || category.dealCategoryName}
                    style={{ display: "block" }}
                  >
                    {category.dealCategoryName || GLOBAL_CONSTANTS.NA}
                    {" → "}
                    {category.statusName || GLOBAL_CONSTANTS.NA}
                  </Text>
                ))}
              </div>
            ),
          },
        ]
      : [
          {
            key: "status",
            label: "Status",
            children:
              user?.userStatusName ||
              user?.statusName ||
              user?.realUserStatusName ||
              GLOBAL_CONSTANTS.NA,
          },
        ]),
    // Only show "RM For" if user is a Relation Manager
    ...(user?.roleName === "relation_manager"
      ? [
          {
            key: "rmFor",
            label: "RM For",
            children: user?.roleForInvestor
              ? "Investor"
              : user?.roleForBusiness
                ? "Business"
                : GLOBAL_CONSTANTS.NA,
          },
        ]
      : []),
  ];

  const rmDetailsItems = [
    { key: "rmName", label: "RM Name", children: user?.rmData?.userName },
    {
      key: "rmPhone",
      label: "RM Phone number",
      children: user?.rmData?.mobile,
    },
    { key: "rmEmail", label: "RM Email", children: user?.rmData?.email },
    {
      key: "location",
      label: "Location",
      children: user?.rmData?.roleCityName || GLOBAL_CONSTANTS.NA,
    },
  ];

  return (
    <div className="user-details-container">
      <BackButton />

      <CustomCard className="user-details-card">
        <Spin spinning={loading}>
          <Descriptions
            title="USER DETAILS"
            bordered
            column={1}
            items={userDetailsItems}
          />
          {user?.rmData?.userName ? (
            <Descriptions
              title="RM DETAILS"
              bordered
              column={1}
              style={{ marginTop: 20 }}
              items={rmDetailsItems}
            />
          ) : user?.UserRole?.roleId === "ROL1000003" ||
            user?.UserRole?.roleId === "ROL1000004" ? (
            <div style={{ marginTop: 20 }}>
              <Text style={{ fontSize: 14, fontWeight: 500 }}>RM DETAILS</Text>
              <div className="rm-details-not-assigned">
                <Text>
                  RM Not Assigned, Please Click "<Text strong>Assign RM</Text>"
                  to Assign the RM
                </Text>
                <CustomButton
                  type="primary"
                  onClick={() => navigate("user-role-management/manage-rm")}
                >
                  Assign RM
                </CustomButton>
              </div>
            </div>
          ) : null}
        </Spin>
      </CustomCard>
    </div>
  );
};

export default UserDetails;
